import React, { ReactElement, ReactNode, RefObject } from 'react';
import { Typography } from '~/UIKit';
import { IconTooltip } from '~/Components/IconTooltip';
import { makeStyles } from '~/UIKit/Style';
import { PRIMARY_BLUE } from '~/Constants/Colors.constants';
import { FONT_SIZE_LARGISH } from '~/Constants/UI.constants';
import { PopperPlacementType } from '@mui/material';

export interface ItemCreationToolTipProps {
  title?: ReactElement;
  icon?: ReactElement;
  boundariesElement?: ReactNode;
  containerRef?: RefObject<HTMLDivElement>;
  placement?: PopperPlacementType;
}

const useStyles = makeStyles(() => ({
  ItemCreationTooltipContainer: {
    flex: 1,
    textAlign: 'right',
    color: PRIMARY_BLUE,
    fontSize: FONT_SIZE_LARGISH,
  },
  itemCreationTooltipTitle: {
    lineHeight: '21px',
  },
  itemCreationTooltipIconContainer: {
    '& > svg': {
      fontSize: '73px',
    },
  },
}));

export const ItemCreationToolTip = ({
  title,
  icon,
  boundariesElement = 'window',
  containerRef,
  placement = 'top-end',
}: ItemCreationToolTipProps) => {
  const { classes } = useStyles();
  if (!title) {
    return null;
  }
  return (
    <div className={classes.ItemCreationTooltipContainer}>
      <IconTooltip
        placement={placement}
        container={containerRef?.current}
        popperOptions={{
          modifiers: [
            {
              name: 'preventOverflow',
              options: {
                boundary: boundariesElement,
              },
            },
          ],
        }}
      >
        {icon && <div className={classes.itemCreationTooltipIconContainer}>{icon}</div>}
        {typeof title === 'string' ? (
          <Typography
            variant="body2"
            className={classes.itemCreationTooltipTitle}
            dangerouslySetInnerHTML={{ __html: title }}
          />
        ) : (
          title
        )}
      </IconTooltip>
    </div>
  );
};
